import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { renderChatBody } from './chat-body.util';

/**
 * bypassSecurityTrustHtml est acceptable ICI UNIQUEMENT parce que
 * renderChatBody() échappe la totalité de l'entrée avant de construire
 * lui-même le HTML (voir chat-body.util.ts).
 */
@Pipe({ name: 'chatBody', standalone: true })
export class ChatBodyPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(body: string | null, mentionNames?: ReadonlyMap<string, string>, mentionFallback?: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(renderChatBody(body, mentionNames, mentionFallback));
  }
}
